/**
 * Quiz email language and resume-link prefix.
 * Locked the first time we know them, then kept across reloads in this tab.
 * Wizard-2 and the new wizards only. Wizard-1 does not load this file.
 */
(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.WizardKlaviyoLocale = api;
})(function () {
  var memory = {};

  function storageKey(flowKey) {
    return 'bz_quiz_locale_' + (flowKey || 'wizard');
  }

  function localePrefixFromPath(pathname) {
    var match = String(pathname || '').match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i);
    return match ? match[1].toLowerCase() : '';
  }

  function languageFromCode(code) {
    var base = String(code || '').toLowerCase().split('-')[0];
    return base === 'en' ? 'en' : 'nl';
  }

  function readStoreLanguage() {
    if (typeof window === 'undefined') return 'nl';
    return languageFromCode(
      window.__wizard2CurrentLocale || window.__wizardCurrentLocale || window.__wizard1CurrentLocale || 'nl'
    );
  }

  function normalizePrefix(prefix) {
    var value = String(prefix || '').trim().toLowerCase();
    if (!value) return '';
    if (value.charAt(0) !== '/') value = '/' + value;
    return localePrefixFromPath(value) || '';
  }

  function normalizeSaved(raw) {
    var language = raw && (raw.language === 'en' || raw.language === 'nl') ? raw.language : '';
    return {
      language: language,
      prefix: normalizePrefix(raw && raw.prefix)
    };
  }

  function readSaved(flowKey) {
    try {
      if (typeof sessionStorage !== 'undefined') {
        var raw = sessionStorage.getItem(storageKey(flowKey));
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && typeof parsed === 'object') {
            var saved = normalizeSaved(parsed);
            memory[flowKey] = saved;
            return saved;
          }
        }
      }
    } catch (e) {}
    return memory[flowKey] ? normalizeSaved(memory[flowKey]) : null;
  }

  function writeSaved(flowKey, saved) {
    var next = normalizeSaved(saved);
    memory[flowKey] = next;
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(storageKey(flowKey), JSON.stringify(next));
      }
    } catch (e) {}
    return next;
  }

  function clear(flowKey) {
    if (flowKey) {
      delete memory[flowKey];
      try {
        if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(storageKey(flowKey));
      } catch (e) {}
      return;
    }
    memory = {};
  }

  /**
   * First language and first real locale prefix win.
   * A saved quiz event can restore them when this tab has not seen them yet.
   */
  function prepare(flowKey, options) {
    options = options || {};
    var saved = readSaved(flowKey) || { language: '', prefix: '' };
    var hinted = options.language === 'en' || options.language === 'nl' ? options.language : '';
    if (!saved.language && hinted) saved.language = hinted;
    if (!saved.language) saved.language = options.fallbackLanguage || readStoreLanguage();
    if (!saved.prefix) saved.prefix = normalizePrefix(options.prefix);
    if (!saved.prefix) saved.prefix = localePrefixFromPath(options.path);
    saved = writeSaved(flowKey, saved);
    if (options.pendingEvent) {
      options.pendingEvent.quizLanguage = saved.language;
      if (saved.prefix) options.pendingEvent.localePrefix = saved.prefix;
    }
    return saved;
  }

  function remember(flowKey, manager, pendingEvent) {
    var candidates = [];
    if (manager && manager.lastPath) candidates.push(manager.lastPath);
    if (typeof location !== 'undefined' && location.pathname) candidates.push(location.pathname);
    var prefixFromPath = '';
    for (var i = 0; i < candidates.length && !prefixFromPath; i += 1) {
      prefixFromPath = localePrefixFromPath(candidates[i]);
    }
    var saved = prepare(flowKey, {
      pendingEvent: pendingEvent || null,
      language: (pendingEvent && pendingEvent.quizLanguage) || (manager && manager._quizLocale && manager._quizLocale.language) || '',
      prefix: (pendingEvent && pendingEvent.localePrefix) || (manager && manager._quizLocale && manager._quizLocale.prefix) || prefixFromPath,
      path: prefixFromPath || candidates[0] || ''
    });
    if (manager) manager._quizLocale = saved;
    return saved;
  }

  function applyPrefixToResumeUrl(url, prefix) {
    if (!url || !prefix) return url;
    var normalized = normalizePrefix(prefix);
    if (!normalized) return url;
    var match = String(url).match(/^(https?:\/\/[^/?#]+)(\/[^?#]*)?(\?[^#]*)?(#.*)?$/i);
    if (!match) return url;
    var path = match[2] || '/';
    if (localePrefixFromPath(path)) return url;
    if (path.charAt(0) !== '/') path = '/' + path;
    return match[1] + normalized + path + (match[3] || '') + (match[4] || '');
  }

  function apply(properties, saved) {
    if (!properties || !saved) return properties;
    properties.language = saved.language === 'en' ? 'en' : 'nl';
    if (properties.wizard_1_resume_url) {
      properties.wizard_1_resume_url = applyPrefixToResumeUrl(properties.wizard_1_resume_url, saved.prefix);
    }
    return properties;
  }

  return {
    localePrefixFromPath: localePrefixFromPath,
    languageFromCode: languageFromCode,
    applyPrefixToResumeUrl: applyPrefixToResumeUrl,
    prepare: prepare,
    remember: remember,
    apply: apply,
    clear: clear
  };
});
